  
  document.addEventListener("DOMContentLoaded", function () {
  const siteHeader = document.querySelector("main-header#site-header");
  if (!siteHeader) return;

  window.addEventListener("scroll", function () {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop >= 40) {
      siteHeader.classList.add("stickyheader");
    } else {
      siteHeader.classList.remove("stickyheader");
    }
  });

   const sidebar = document.querySelector(".siderbar");
  if (sidebar) {
    sidebar.style.display = "none";
    setInterval(function () {
      sidebar.style.display = "";
    }, 500);
  }

  // scrollTop arrow

  const scrollBtn = document.getElementById("scrollToTop");
  const footer = document.querySelector(".footer-container");

  function toggleScrollBtn() {
    // Run only if screen width <= 767px (mobile)
    if (window.innerWidth <= 767 && footer) {
      const footerTop = footer.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      if (footerTop <= windowHeight) {
        scrollBtn.style.display = "flex";
      } else {
        scrollBtn.style.display = "none";
      }
    } else {
      // Hide button on desktop
      scrollBtn.style.display = "none";
    }
  }

  // Run on scroll + resize
  window.addEventListener("scroll", toggleScrollBtn);
  window.addEventListener("resize", toggleScrollBtn);

  // Smooth scroll to top
  scrollBtn.addEventListener("click", function () {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  // Initial check
  toggleScrollBtn();



(function () {
  // Run when DOM is ready
  function onReady(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  // Move .jdgm-revs-tab after the write-review link (idempotent)
  function insertbtnm() {
    var btn = document.querySelector(".jdgm-revs-tab");
    var target = document.querySelector(".jdgm-row-stars .jdgm-widget-actions-wrapper .jdgm-write-rev-link");
    if (!btn || !target) return;

    // Already in the right spot? bail.
    if (target.nextElementSibling === btn) return;

    target.insertAdjacentElement("afterend", btn);
  }

  // Throttle re-runs during heavy DOM mutations
  var scheduled = false;
  function scheduleInsert() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      insertbtnm();
    });
  }

  onReady(function () {
    // Initial attempt
    insertbtnm();

    // Observe widget (or body as fallback) for AJAX-driven changes
    var root = document.querySelector(".jdgm-widget") || document.body;
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === "childList") {
          scheduleInsert();
          break;
        }
      }
    });
    obs.observe(root, { childList: true, subtree: true });

    // Also try once at full page load (some widgets finish after DOMContentLoaded)
    window.addEventListener("load", insertbtnm);

    // Fallback poll (stops after 10s)
    var start = Date.now();
    var poll = setInterval(function () {
      insertbtnm();
      if (Date.now() - start > 10000) clearInterval(poll);
    }, 300);
  });
})();

   const observer = new MutationObserver(() => {
    const openBtn = document.querySelector(".jdgm-widget-actions-wrapper .jdgm-revs-tab-btn.btn");
    const closeBtns = document.querySelectorAll(".jdgm-close-ico, .jdgm-mask");
    const reviewsTab = document.querySelector(".jdgm-revs-tab");

    if (openBtn && reviewsTab) {
      openBtn.addEventListener("click", () => reviewsTab.classList.add("active-rev"));
    }

    if (closeBtns.length && reviewsTab) {
      closeBtns.forEach(btn =>
        btn.addEventListener("click", () => reviewsTab.classList.remove("active-rev"))
      );
    }

    // stop observing once found
    if (openBtn && closeBtns.length && reviewsTab) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

});


 

